export const CREATE_ORDER_REQUEST = "ORDER.CREATE_ORDER_REQUEST";
export const CREATE_ORDER_SUCCESS = "ORDER.CREATE_ORDER_SUCCESS";
export const CREATE_ORDER_FAILURE = "ORDER.CREATE_ORDER_FAILURE";

export const GET_MY_ORDER_REQUEST = "ORDER.GET_MY_ORDER_REQUEST";
export const GET_MY_ORDER_SUCCESS = "ORDER.GET_MY_ORDER_SUCCESS";
export const GET_MY_ORDER_FAILURE = "ORDER.GET_MY_ORDER_FAILURE";

export const GET_ALL_ORDERS_REQUEST = "ORDER.GET_ALL_ORDERS_REQUEST";
export const GET_ALL_ORDERS_SUCCESS = "ORDER.GET_ALL_ORDERS_SUCCESS";
export const GET_ALL_ORDERS_FAILURE = "ORDER.GET_ALL_ORDERS_FAILURE";

export const GET_SELECTED_ORDER_REQUEST = "ORDER.GET_SELECTED_ORDER_REQUEST";
export const GET_SELECTED_ORDER_SUCCESS = "ORDER.GET_SELECTED_ORDER_SUCCESS";
export const GET_SELECTED_ORDER_FAILURE = "ORDER.GET_SELECTED_ORDER_FAILURE";

export const UPDATE_STATUS_ORDER_REQUEST = "ORDER.UPDATE_STATUS_ORDER_REQUEST";
export const UPDATE_STATUS_ORDER_SUCCESS = "ORDER.UPDATE_STATUS_ORDER_SUCCESS";
export const UPDATE_STATUS_ORDER_FAILURE = "ORDER.UPDATE_STATUS_ORDER_FAILURE";

export const CREATE_BY_ADMIN_REQUEST = "ORDER.CREATE_BY_ADMIN_REQUEST";
export const CREATE_BY_ADMIN_SUCCESS = "ORDER.CREATE_BY_ADMIN_SUCCESS";
export const CREATE_BY_ADMIN_FAILURE = "ORDER.CREATE_BY_ADMIN_FAILURE";
